import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { usePaginate } from '../../hooks/usePaginate';
import { usePagination } from '../../hooks/usePagination';
import { clearNotifications, removeNotification } from '../../store/reducers/uiReducer';

import { NumberedPagination } from '../common/pagination/NumberedPagination';
import { NotificationsListItem } from './NotificationsListItem';
import { NotificationEmptyIcon } from './NotificationEmptyIcon';
import { EmptyCard } from '../common/ui/EmptyCard';

export const NotificationsList = ({ notifications: allNotifications }) => {
    const dispatch = useDispatch();
    const paginate = usePaginate();
    const { pagination, handlers } = usePagination();
    const notifications = paginate(allNotifications, pagination);

    if (notifications.total === 0) {
        return (
            <EmptyCard
                emptyIcon={NotificationEmptyIcon}
                text="No new notifications"
                textClassName="text-muted mt-3 mb-1">
                <p className="text-muted mb-1">Any new notification will appear here</p>
                <Link to="/" className="btn btn-outline-primary mt-3">
                    Return to home
                </Link>
            </EmptyCard>
        );
    }

    const handleClearNotifications = () => {
        dispatch(clearNotifications());
    };

    const handleRemoveItem = (notification) => {
        dispatch(removeNotification(notification));
    };

    return (
        <React.Fragment>
            <div className="row">
                <div className="col">
                    <button
                        className="btn btn-outline-primary float-end"
                        onClick={handleClearNotifications}>
                        Clear all notifications
                    </button>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <ul className="list-group my-3">
                        {notifications.records.map((notification) => (
                            <NotificationsListItem
                                key={notification.id}
                                onRemove={handleRemoveItem}
                                notification={notification}
                            />
                        ))}
                    </ul>
                    <NumberedPagination data={notifications} {...handlers} />
                </div>
            </div>
        </React.Fragment>
    );
};
